import { IUser } from 'types/user';
import { create } from 'zustand';

interface IUserStore {
  userData: IUser | null;
  isUserDataLoading: boolean;

  setUserDataLoading: (isUserDataLoading: boolean) => void;
  setUserData: (userData: IUser | null) => void;
}

export const userStore = create<IUserStore>((set) => ({
  userData: null,
  isUserDataLoading: false,

  setUserDataLoading: (isUserDataLoading: boolean) => set({ isUserDataLoading }),
  setUserData: (userData: IUser | null) => set((state) => ({ ...state, userData })),
}));

export const useUserStore = userStore;
